import { UserSessionWidgetComponent } from '../User/UserSessionWidgetComponent';

export const TopBarComponent = () => {
  return (
    <div className="topBar">
      <UserSessionWidgetComponent />
    </div>
  );
};
